<div class="section-title">Operation datafiles</div>
<p>Views what datafiles were data sources for a particular operation.</p>
@if (assetOps !== undefined) {
<select class="form-control op-list" [(ngModel)]="selectedOperation" (ngModelChange)="GetDatafiles()"
	title="Showing {{ assetOps && assetOps.length >= ADMIN_OPERATIONS_LIMIT ? 'latest ' + ADMIN_OPERATIONS_LIMIT : 'all' }} operations">
	@for (operation of assetOps; track operation) {
	<option [ngValue]="operation" [class]="GetOpClass(operation)">
		{{operation.start_time | datetime : "offset" : asset.time_offset_hours}}{{operation.rotor_turn_time | runtime : " Rotor:"}}{{operation.flight_time | runtime :
		" Flight: "}}{{operation.exceedance_count > 0 ? " Ex: " + operation.exceedance_count : ""}}{{operation.exceedance_count && operation.exceedance_ack_by ? " (ack)" : ""}}
	</option>
	}
</select>
}
@if (assetOps === undefined) {
<select class="form-control" disabled>
	<option>Loading operations...</option>
</select>
}
@if (opDatafiles !== undefined && opDatafiles.length > 0) {
<table class="log compact mt-3" [class.loading]="datafilesLoading">
	<thead>
		<tr>
			<th>Filename</th>
			<th>Import Date</th>
			<th>Size</th>
			<th>Status</th>
		</tr>
	</thead>
	@for (datafile of opDatafiles; track datafile) {
	<tbody>
		<tr>
			<td><a (click)="DownloadFile(datafile)" href="javascript:void(0)"><i class="icon-doc"></i> {{datafile.filename}}</a></td>
			<td>{{datafile.imported | datetime : "offset" : asset.time_offset_hours}}</td>
			<td>{{datafile.size | filesize}}</td>
			<td>{{datafile.status}}</td>
		</tr>
	</tbody>
	}
</table>
}
@if (opDatafiles !== undefined && opDatafiles.length === 0) {
<p>No datafiles for this operation.</p>
}

<hr class="my-4">
<h5>Regenerate HI values</h5>
<p>Recalculates all HI values from imported CI values using the current config.</p>
<p>Note that regenerating HIs can take some time and will wipe out any history of alternate engine
	config. You should recalculate states (below) afterwards.</p>
<div class="row my-3">
	<div class="col-sm-5">
		<app-action-button [action]="GenerateHIs" [context]="this" processing="Generating..." complete="HIs regenerated">Regenerate HI values</app-action-button>
	</div>
	<div class="col-sm-7">
		@if (hiStatus) {
		<p>
			<ngb-progressbar type="success" [value]="hiProgress"></ngb-progressbar>
		</p>
		}
		{{hiStatus}}
	</div>
</div>

<hr class="my-4">
<h5>Recalculate component states</h5>
<p>Deletes and recalculates states (normal, warning, alarm) for each component based on the most recent acquisitions.</p>
<p>Recalculate component states when the underlying data has been changed but components are still in warning.</p>
<div class="row my-3">
	<div class="col-sm-5">
		<app-action-button [action]="RecalculateStates" [context]="this" processing="Recalculating..." complete="States recalculated">Recalculate component states</app-action-button>
	</div>
	<div class="col-sm-7">
		@if (statesStatus) {
		<p>
			<ngb-progressbar type="success" [value]="statesProgress"></ngb-progressbar>
		</p>
		}
		{{statesStatus}}
	</div>
</div>